export enum ImportErrorKind {
    InvalidArchiveFormat = 1
}

export enum ImportedItemErrorKind {
    Unknown = 'Unknown',
    NonUnique = 'NonUnique',
    PriceListNotFound = 'PriceListNotFound',
    VatRateNotFound = 'VatRateNotFound',
    UnitNotFound = 'UnitNotFound',
    SymbolIsNull  = 'SymbolIsNull',
    SymbolNonUnique = 'SymbolNonUnique',
    NameNonUnique = 'NameNonUnique'
}
